import { Route, Routes } from "react-router-dom";
import { MainLayout } from "../layout";
import { MobileUpload } from "../layout/pages/MobileUpload.jsx";
import { PreviewPage } from "../layout/pages/PreviewPage.jsx";
import LoginPage from "../layout/pages/LoginPage.jsx";
import ImportLayoutsPage from "../layout/pages/ImportLayoutsPage.jsx";
import { ThemeProvider } from "styled-components";
import { GlobalStyles, theme } from "../common-components/StyledComponents.jsx";
import "../library/utils/custom-hooks/useInitializeShader.js";
function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <div className="App">
              <MainLayout />
            </div>
          }
        />
        <Route path="/upload/:projectId" element={<MobileUpload />} />
        <Route path="/test" element={<MobileUpload />} />
        <Route path="/preview" element={<PreviewPage />} />
        {/* <Route path="/admin/import-layouts" element={<ImportLayoutsPage />} /> */}
      </Routes>
    </ThemeProvider>
  );
}
export default App;
